export default {
  login: 'login',
  public: 'public',
  dashboard: 'dashboard',
};
